import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { AreaTypeEnum } from '../../../shared/modules/settings/enums/area-type.enum';
import { MapCoordinateDto } from '../../../shared/modules/shared/dtos/map-coordinate.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { LocationStatusEnum } from '../enums/location-status.enum';
import { LocationTypeEnum } from '../enums/location-type.enum';

/**
 * Location DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.LOCATION)
export class LocationSearchDto extends BaseSearchDto {
  code!: string;
  name!: string;
  status!: LocationStatusEnum;
  type!: LocationTypeEnum;
  areaName!: string;
  areaType!: AreaTypeEnum;
  isPickUp?: boolean | null;
  isDropOff?: boolean | null;
  gpsCoordinates!: MapCoordinateDto;
  files?: FileDto[] | null;
  tags?: TagListDto[] | null;
}
